define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var core = require('core');
    var i18n = require('i18n');
    var PopupView = require('modules/popup/popup.view');
    var LimitsView = require('portlets/responsible-gaming/limits/limits.view');

    module.exports = PopupView.extend({
        isOpened: false,
        className: PopupView.prototype.className + ' popup_type_loss_limit',

        initialize: function() {
            // Only one instance of Limits pop-up can be opened
            if (this.constructor.prototype.isOpened) {
                return;
            }

            this.setLimitsTranslations();
            this.constructor.prototype.isOpened = true;
            PopupView.prototype.initialize.apply(this, arguments);

            core.trigger('limitPopup:opened');
        },

        setOptions: function(options) {
            options = options || {};
            options.data = options.data || {};

            this.options.priority = 'hight';
            this.options.isModal = true;
            this.options.closeAll = false;
            this.options.order = 0;

            _.extend(this.options.data, {
                articleId: 'LOSS_LIMIT_POPUP_CONTENT',
                title: i18n.t('playtech.mobile.system.ngresponsiblegaming.limits.lossLimit.heading'),
                buttons: false,
                content: this.tmpl('limits.popup'),
                limitsCallback: this.close.bind(this)
            });

            this.childViews.push(new LimitsView(this.options.data));
        },

        renderContent: function() {
            var limitsView = this.childViews[0];

            this.$el.find('.popup-webcontent-container').append(this.options.data.article);
            this.$el.find('.popup-limits-container').append(limitsView.$el);
            this.calculatePopupContentHeight();
        },

        close: function() {
            var state = PopupView.prototype.close.apply(this, arguments);

            state.done(function() {
                this.constructor.prototype.isOpened = false;
                core.trigger('limitPopup:closed');
            }.bind(this));
            return state;
        },

        setLimitsTranslations() {
            var prefix = 'playtech.mobile.system.ngresponsiblegaming.limits';
            var translations = _.keys(i18n.translations).reduce(function(obj, key) {
                if (key.includes(prefix)) {
                    obj[key.replace('.system', '')] = i18n.translations[key];
                }

                return obj;
            }, {});

            i18n.setTranslations(translations);
        }
    });
});
